import React from 'react';
import PropTypes from 'prop-types';
import ScrollableAnchor from 'react-scrollable-anchor';

import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';

import './Navigation.module.css';

Navigation.propTypes = {
  data: PropTypes.object,
};

function Navigation({ data }) {
  return (
    <ScrollableAnchor id="toTop">
      <div>
        <DesktopNavigation data={data} />
        <MobileNavigation data={data} />
      </div>
    </ScrollableAnchor>
  );
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Header/Navigation.js